import _get from "@babel/runtime/helpers/get";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Writable } from 'stream';
import MicrophoneStream from 'microphone-stream';
import audioContext from 'audio-context';
import getUserMedia from 'getusermedia';
import keyboardjs from 'keyboardjs';
import DropStream from 'drop-stream';

var VoiceHandler = /*#__PURE__*/function (_Writable) {
  _inherits(VoiceHandler, _Writable);

  var _super = _createSuper(VoiceHandler);

  function VoiceHandler(index, client, settings) {
    var _this;

    _classCallCheck(this, VoiceHandler);

    _this = _super.call(this, {
      objectMode: true
    });
    _this._index = index; //zcx add, to get current channel id

    _this._client = client;
    _this._settings = settings;
    _this._outbound = null;
    _this._mute = false;
    return _this;
  }

  _createClass(VoiceHandler, [{
    key: "setMute",
    value: function setMute(mute) {
      this._mute = mute;

      if (mute) {
        this._stopOutbound();
      }
    }
  }, {
    key: "nowTalk",
    value: function nowTalk() {
      this._pushed = true;
    }
  }, {
    key: "pttDown",
    value: function pttDown() {
      var chanName = this._index.thisUser().channel().name();

      var posLeft = chanName.lastIndexOf('(');
      var posRight = chanName.lastIndexOf(')');
      var strId = chanName.substring(posLeft + 1, posRight);
      var iId = parseInt(strId);

      this._client.applyMic(iId, true);
    }
  }, {
    key: "pttUp",
    value: function pttUp() {
      //发现后1-2个字被吞，所以延迟一会放麦
      var chanName = this._index.thisUser().channel().name();

      var posLeft = chanName.lastIndexOf('(');
      var posRight = chanName.lastIndexOf(')');
      var strId = chanName.substring(posLeft + 1, posRight);
      var iId = parseInt(strId);
      var tmpClient = this._client;
      var tmpThis = this;

      function doPttUp() {
        //先UserTalking(false)
        tmpClient.reportTalking(false);
        tmpClient.applyMic(iId, false);

        tmpThis._stopOutbound();

        tmpThis._pushed = false;
      }

      setTimeout(doPttUp, 300);
    }
  }, {
    key: "_getOrCreateOutbound",
    value: function _getOrCreateOutbound() {
      if (this._mute) {
        throw new Error('tried to send audio while self-muted');
      }

      if (!this._outbound) {
        if (!this._client) {
          this._outbound = DropStream.obj();
          this.emit('started_talking');
          return this._outbound;
        } // Note: the samplesPerPacket argument is handled in worker.js and not passed on
        //this._outbound = this._client.createVoiceStream(this._settings.samplesPerPacket)


        this._outbound = this._client.createVoiceStream(960); //发现localhost访问正常960，ip地址访问就是160.所以写死960

        this.emit('started_talking');
      }

      return this._outbound;
    }
  }, {
    key: "_stopOutbound",
    value: function _stopOutbound() {
      if (this._outbound) {
        this.emit('stopped_talking');

        this._outbound.end();

        this._outbound = null;
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      this._stopOutbound();

      callback();
    }
  }]);

  return VoiceHandler;
}(Writable);

export var PushToTalkVoiceHandler = /*#__PURE__*/function (_VoiceHandler) {
  _inherits(PushToTalkVoiceHandler, _VoiceHandler);

  var _super2 = _createSuper(PushToTalkVoiceHandler);

  function PushToTalkVoiceHandler(index, client, settings) {
    var _this2;

    _classCallCheck(this, PushToTalkVoiceHandler);

    _this2 = _super2.call(this, index, client, settings);
    _this2._key = settings.pttKey;
    _this2._pushed = false;

    _this2._keydown_handler = function () {
      _this2.pttDown();
    };

    _this2._keyup_handler = function () {
      _this2.pttUp();
    };

    keyboardjs.bind(_this2._key, _this2._keydown_handler, _this2._keyup_handler);
    return _this2;
  }

  _createClass(PushToTalkVoiceHandler, [{
    key: "_write",
    value: function _write(data, _, callback) {
      if (this._pushed && !this._mute) {
        this._getOrCreateOutbound().write(data, callback);
      } else {
        callback();
      }
    }
  }, {
    key: "_final",
    value: function _final(callback) {
      var _this3 = this;

      _get(_getPrototypeOf(PushToTalkVoiceHandler.prototype), "_final", this).call(this, function (e) {
        keyboardjs.unbind(_this3._key, _this3._keydown_handler, _this3._keyup_handler);
        callback(e);
      });
    }
  }]);

  return PushToTalkVoiceHandler;
}(VoiceHandler);
var theUserMedia = null;
export function initVoice(onData, onUserMediaError) {
  getUserMedia({
    audio: true
  }, function (err, userMedia) {
    if (err) {
      onUserMediaError(err);
    } else {
      theUserMedia = userMedia;
      var micStream = new MicrophoneStream(userMedia, {
        objectMode: true,
        bufferSize: 1024
      });
      micStream.on('data', function (data) {
        onData(Buffer.from(data.getChannelData(0).buffer));
      });
    }
  });
}